import { Tab, withStyles } from '@material-ui/core'
import { GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI/colors.constant'
import React from 'react'

const AsterTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    fontSize: 14,
    fontWeight: 600,
    padding: '10px 14px',
    borderRadius: 8,
    minWidth: 'unset',
    color: GRAY_COLORS[500],
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700]
    },
    '&$selected': {
      color: SUCCESS_COLORS[700],
      backgroundColor: SUCCESS_COLORS[50],
      fontWeight: 600,
      '&:hover': {
        backgroundColor: SUCCESS_COLORS[100]
      }
    }
  },
  selected: {}
}))(props => <Tab disableRipple {...props} />)
export default AsterTab
